import {
  dishCategoryKey,
  dishCostKey,
  dishNameKey,
  dishPhotoKey,
  dishSectionKey,
  filterByLangValue,
  getSortField,
  getSortValue,
  sortByCost,
  sortByExist,
  sortByLangValue,
  sortKey,
} from '../../../../../../features/table/helpers';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { DishType } from '../../../../../../store/api/dish-api';
import { SortType } from '../../../../../../types/props';

export const useMenuInformerTableFilters = (dishes: DishType[] = []) => {
  const { getQueryParams } = useQueryParams();
  const params = getQueryParams();
  const photo = params[dishPhotoKey];
  const name = params[dishNameKey];
  const available = params.available;
  const category = params[dishCategoryKey];
  const section = params[dishSectionKey];
  const cost = params[dishCostKey];
  const sort = params[sortKey];
  const field = getSortField(sort);
  const dir = getSortValue(sort);

  let list = [...dishes];

  if (photo) {
    const isPhoto = photo === 'true';
    list = list.filter((item) =>
      isPhoto ? !!item.images.main?.normal : !item.images.main?.normal,
    );
  }
  if (name) {
    list = list.filter((item) => filterByLangValue(item.name, name));
  }
  if (category?.length) {
    const selectedCategories = category.split(',');
    list = list.filter((item) => selectedCategories.includes(String(item.category_id)));
  }
  if (section?.length) {
    const selectedSections = section.split(',');
    list = list.filter((item) => selectedSections.includes(String(item.section_id)));
  }
  if (cost) {
    const { from, to } = JSON.parse(cost);

    list = list.filter((item) => {
      const price = item.prices.primary.price;
      if (!price) return false;
      const isWithinFrom = !from || price >= Number(from);
      const isWithinTo = !to || price <= Number(to);
      return isWithinFrom && isWithinTo;
    });
  }

  if (available) {
    list = list.filter((item) => (available === 'true' ? item.is_on : !item.is_on));
  }

  if (field === 'available') {
    list = list.sort((a, b) => sortByExist(a.is_on, b.is_on, dir as SortType));
  }

  if (field === 'photo') {
    list = list.sort((a, b) =>
      sortByExist(!!a.images.main?.normal, !!b.images.main?.normal, dir as SortType),
    );
  }

  if (field === dishNameKey) {
    list = list.sort((a, b) => sortByLangValue(a.name, b.name, dir as SortType));
  }
  if (field === 'category') {
    list = list.sort((a, b) => sortByCost(a.category_id, b.category_id, dir as SortType));
  }
  if (field === 'section') {
    list = list.sort((a, b) => sortByCost(a.section_id, b.section_id, dir as SortType));
  }

  if (field === 'cost') {
    list = list.sort((a, b) =>
      sortByCost(a.prices.primary.price, b.prices.primary.price, dir as SortType),
    );
  }

  return list;
};
